import { render } from "./TermAndCondition.vue?vue&type=template&id=73a27820&scoped=true"
import script from "./TermAndCondition.vue?vue&type=script&scoped=true&lang=js"
export * from "./TermAndCondition.vue?vue&type=script&scoped=true&lang=js"

import "../../../../assets/css/agreement.css?vue&type=style&index=0&id=73a27820&scoped=true&lang=css"
script.render = render
script.__scopeId = "data-v-73a27820"

export default script